<template>
  <div>
    <hshead title="店铺客户" waveBg="true"></hshead>
    <div class="tabs-box">
      <van-tabs v-model="tabactive" swipeable title-active-color="#007dfa" color="#007dfa">
        <van-tab title="酒店列表">
          <div class="city-ul">
            <van-list v-model="loadingByHotel" :finished="finishedByHotel" finished-text="" @load="onLoadByHotel">
              <div class="city-li" v-for="(item, index) in listByHotel" :key="index">
                <van-cell-group>
                  <van-cell :title="item.hotelName" :value="item.provinceName + ' ' + item.cityName" :label="item.hotelAddress" />
                </van-cell-group>
              </div>
            </van-list>
            <div v-if="finishedByHotel" class="emptyDataDiv" style="color:#666;">
              <div v-if="listByHotel.length==0">
                <van-icon name="info" color="#666" />
                <p>暂无酒店</p>
              </div>
              <!-- <div v-else>没有更多了</div> -->
            </div>
          </div>
        </van-tab>
        <van-tab title="协议列表">
          <div class="city-ul">
            <van-list v-model="loadingByAgreement" :finished="finishedByAgreement" finished-text="" @load="onLoadByAgreement">
              <div class="city-li" v-for="(item, index) in listByAgreement" :key="index">
                <van-cell-group>
                  <van-cell :title="item.agreementName" :value="item.mobile" :label="item.address" />
                </van-cell-group>
              </div>
            </van-list>
            <div v-if="finishedByAgreement" class="emptyDataDiv" style="color:#666;">
              <div v-if="listByAgreement.length==0">
                <van-icon name="info" color="#666" />
                <p>暂无协议信息</p>
              </div>
              <div v-else>没有更多了</div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <van-tabbar v-model="active">
      <van-tabbar-item to="MissionHall">
        <span>任务中心</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_taskCenter.active : icon_taskCenter.inactive
            "
          />
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="Income" icon="chart-trending-o">
        <span>收益</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_earnings.active : icon_earnings.inactive
            "
          />
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="Grapher" icon="manager-o">
        <span>摄影师</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_cameraman.active : icon_cameraman.inactive
            "
          />
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="Product" icon="orders-o">
        <span>商品管理</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_product.active : icon_product.inactive
            "
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Other" icon="apps-o">
        <span>更多</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_more.active : icon_more.inactive
            "
          />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>

import hshead from "@/components/common/hshead";
import { Toast, Tab, Tabs, List, Tabbar, TabbarItem,Cell, CellGroup, Icon  } from "vant";
import { getHotelPager, getAgreementPager } from "@/api/m/store";
// 任务中心
import taskCenter_icon from "@/assets/images/center/nav-1.png";
import taskCenter_icon_act from "@/assets/images/center/nav-1-act.png";
//收益
import earnings_icon from "@/assets/images/center/nav-2.png";
import earnings_icon_act from "@/assets/images/center/nav-2-act.png";
//摄影师
import cameraman_icon from "@/assets/images/center/nav-3.png";
import cameraman_icon_act from "@/assets/images/center/nav-3-act.png";
//商品管理
import product_icon from "@/assets/images/center/nav-4.png";
import product_icon_act from "@/assets/images/center/nav-4-act.png";
//更多
import more_icon from "@/assets/images/center/nav-5.png";
import more_icon_act from "@/assets/images/center/nav-5-act.png";

export default {
  name: "shopCustomers",
  data() {
    return {
      tabactive: 0,
      active: 4,
      //酒店
      listByHotel: [],
      loadingByHotel: false,
      finishedByHotel: false,
      listQueryByHotel: {
        pn: 1,
        ps: 20,
      },
      //协议公司
      listByAgreement: [],
      loadingByAgreement: false,
      finishedByAgreement: false,
      listQueryByAgreement: {
        pn: 1,
        ps: 20,
      },
      icon_taskCenter: {
        active: taskCenter_icon_act,
        inactive: taskCenter_icon,
      },
      icon_earnings: {
        active: earnings_icon_act,
        inactive: earnings_icon,
      },
      icon_cameraman: {
        active: cameraman_icon_act,
        inactive: cameraman_icon,
      },
      icon_product: {
        active: product_icon_act,
        inactive: product_icon,
      },
      icon_more: {
        active: more_icon_act,
        inactive: more_icon,
      },
    };
  },
  methods: {
    onLoadByHotel() {
      this.getHotelPager();
    },
    onLoadByAgreement() {
      this.getAgreementPager();
    },
    //酒店列表数据
    getHotelPager() {
      getHotelPager(this.listQueryByHotel).then(response => {
        console.info('response', response)
        const { code, msg, data } = response;
        if (code >= 0) {
          console.info('getHotelPager -> data', data)
          this.listQueryByHotel.pn = this.listQueryByHotel.pn + 1
          //
          if(data.totalRecord == 0){
            this.loadingByHotel = false;
            this.finishedByHotel = true;
          }
          else {
            data.list.map(item => {
              this.listByHotel.push(item)
            })
            // 加载状态结束
            this.loadingByHotel = false;
            // 数据全部加载完成
            if (this.listByHotel.length >= data.totalRecord) {
              this.finishedByHotel = true;
            }
          }
        }
      })
      .catch(response => {
        //this.tips(`${response.msg}`);
        Toast.fail({duration:1000 * 5, message: `${response.msg}`});
      });
    },
    //协议公司列表数据
    getAgreementPager() {
      getAgreementPager(this.listQueryByAgreement).then(response => {
        console.info('response', response)
        const { code, msg, data } = response;
        if (code >= 0) {
          console.info('getAgreementPager -> data', data)
          this.listQueryByAgreement.pn = this.listQueryByAgreement.pn + 1
          //
          if(data.totalRecord == 0){
            this.loadingByAgreement = false;
            this.finishedByAgreement = true;
          }
          else {
            data.list.map(item => {
              this.listByAgreement.push(item)
            })
            // 加载状态结束
            this.loadingByAgreement = false;
            // 数据全部加载完成
            if (this.listByAgreement.length >= data.totalRecord) {
              this.finishedByAgreement = true;
            }
          }
        }
      })
      .catch(response => {
        //this.tips(`${response.msg}`);
        Toast.fail({duration:1000 * 5, message: `${response.msg}`});
      });
    },
  },
  components: {
    hshead,
    "van-list": List,
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-tabbar": Tabbar,
    "van-tabbar-item": TabbarItem,
    'van-cell':Cell,
    'van-cell-group':CellGroup,
    "van-icon": Icon
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";
@import "~@/assets/less/mixin.less";
.tabs-box {
  margin-top: -4.3rem;
}
.city-ul{
  padding-top: 0.4rem;
}
.city-ul .city-li {
    width: 6.7rem;
    // height: 2.01rem;
    background-color: #fff;
    -webkit-box-shadow: 0 0.01rem 0.18rem 0 rgba(129,135,148,.18);
    box-shadow: 0 0.01rem 0.18rem 0 rgba(129,135,148,.18);
    border-radius: .06rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: block !important;
    margin: 0 auto .35rem;
}

</style>


// WEBPACK FOOTER //
// src/views/store/shopCustomers.vue